import { Button, Card, message, Popconfirm, Space, Image } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import AddCollabaration from "./AddCollabaration";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

function CollabarationTable() {
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteResponse, deleteRequest] = useApi();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (text, record) => <Image src={text} width={100} />,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title="Delete Collaboration"
                description={`Are you sure to delete this collaboration?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/collaboration?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();

      messageApi.open({
        type: "success",
        content: "Collaboration Deleted successfully",
      });
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  const handleAddCollaboration = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditCollaboration = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(
      null,
      API_METHODS.DELETE,
      `/admin/collaboration/${record.id}`
    );
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/collaboration?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Collaboration"
      extra={
        <Button type="default" onClick={handleAddCollaboration}>
          Add Collaboration
        </Button>
      }
    >
      {contextHolder}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visible && (
        <AddCollabaration visible={visible} close={handleAddCollaboration} />
      )}
      {visibleEdit && (
        <AddCollabaration
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditCollaboration}
        />
      )}
    </Card>
  );
}

export default CollabarationTable;
